"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgTag = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.16 22.953L1.382 11.384A3.784 3.784 0 01.37 8.96L.363 2.465a2 2 0 012-2h6.492a3.75 3.75 0 012.39.981c.02.017.036.034.054.053V1.5l11.739 11.544a2 2 0 01.012 2.841l-7.065 7.063a2 2 0 01-2.808.021l-.017-.016zM6.363 4.965a1.5 1.5 0 100 3 1.5 1.5 0 000-3z", clipRule: "evenodd" })));
};
exports.default = SvgTag;
//# sourceMappingURL=Tag.js.map